import { login } from '../../../api/login/loginApi';
import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT
} from '../../types/login/loginTypes';

export const loginUser = ({ username, password }) => async (dispatch) => {
  dispatch({ type: LOGIN_REQUEST });
  try {
    const data = await login(username, password);
    // Save the token to localStorage
    if (data.token) {
      localStorage.setItem('token', data.token);
    }
    dispatch({ type: LOGIN_SUCCESS, payload: data.user });
  } catch (error) {
    dispatch({ type: LOGIN_FAILURE, error: error.message });
  }
};

export const logout = () => ({ type: LOGOUT });

export const loadUserFromToken = () => async (dispatch) => {
  const token = localStorage.getItem('token');
  if (token) {
    try {
      // Use axiosInstance to send the token automatically
      const res = await require('../../../utills/axiosConfig').default.get('/auth/me');
      dispatch({ type: LOGIN_SUCCESS, payload: res.data.user });
    } catch (err) {
      localStorage.removeItem('token');
    }
  }
};
